import * as React from 'react';
import { LightableEnableWebPushCallout } from './LightableEnableWebPushCallout';
import { when } from '../utils/when';
import { observer } from 'mobx-react';
import { LightningId } from 'owa-lightning-v2';

export interface EnableWebPushLightningCalloutProps {
    target: () => HTMLElement;
}

@observer
export class EnableWebPushLightningCallout extends React.Component<
    EnableWebPushLightningCalloutProps,
    {}
> {
    render() {
        return (
            <LightableEnableWebPushCallout
                lid={LightningId.WebPushPromotion}
                when={when}
                target={this.props.target}
            />
        );
    }
}
